import styled, { keyframes } from 'styled-components'; // Import keyframes

export const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const Content = styled.div`
  background:#fafafa;
  height: 100%;
  overflow-y: auto; /* Enable scrolling for content if it overflows */
`;

export const NavMenu = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ContentContainer = styled.div`
  padding: 3rem;

  h1 {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
    margin-top: 2rem;
    color: var(--black);

    svg{
      margin-right: 1rem;
    }
  }

  h1:first-child{
    margin-top: 0;
  }

  h3 { /* Style for "Nenhum usuário/artigo encontrado" */
    text-align:center;
    margin-top: 2rem;
    color: var(--gray);
  }
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eee; /* Added border-bottom for visual separation */
  padding-bottom: 2rem; /* Added padding */
  margin-bottom: 2rem; /* Added margin */


  a{
    background: var(--light-black);
    color: #fff;
    padding: 1rem 2rem;
    font-weight: 700;
    border-radius: 4px;
    text-decoration: none;
    transition: background 0.2s; /* Smooth transition for hover */
  }

  a:hover{
    background: var(--yellow);
  }

  form{
    display:flex;
    flex-direction: row;
    align-items: center; /* Align selects */

    >div{
      margin: 0 0.5rem; /* Spacing between selects */
    }
  }
`;

export const TitleTable = styled.div`
  display:flex;
  margin-top: 2rem;
  padding: 1rem;
  background: var(--light-black); /* Consistent header background */
  color: #fff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;

  span{
    width: 100%;
    text-align:center;
    font-weight: 600; /* Make header text bolder */
  }
`;

export const Line = styled.div`
  border: 1px solid #eee;
  background: #fff;
  margin-bottom: -1px; /* Overlap borders to prevent double lines */

  &:first-of-type {
    border-top-width: 0; /* Remove top border of first line, as TitleTable has rounded corners */
  }

  &:last-of-type {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  > div:first-child{ /* This is the main row content */
    display:flex;
    padding: 1rem;
    align-items: center; /* Align content vertically */
    transition: background 0.2s;

    &:hover {
      background: #f0f0f0; /* Hover effect for the main row */
    }

    span{
      width: 100%;
      text-align:center;
      padding: 0 0.5rem; /* Add some horizontal padding to content */
    }

    .status-pending {
      color: var(--yellow);
      font-weight: bold;
    }
    .status-approved {
      color: var(--green);
      font-weight: bold;
    }
    .status-rejected {
      color: var(--red);
      font-weight: bold;
    }


    .action_div{
      display:flex;
      flex-direction: row;
      align-items:center;
      justify-content: flex-end; /* Align actions to the right */
      width: 100%;
      min-width: 250px; /* Ensure enough space for action buttons */

      .actions{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:center;
        padding: 0.5rem 1rem; /* Padding for click area */
        border-radius: 4px;
        cursor: pointer;
        color: #444;
        margin: 0 0.2rem; /* Smaller margin between actions */
        white-space: nowrap; /* Prevent text wrapping */
        transition: background 0.2s, color 0.2s; /* Smooth transitions */

        svg{
          margin-right: 0.5rem;
        }

        a{
          display:flex;
          flex-direction: row;
          align-items:center;
          color: inherit; /* Inherit color from parent div */
          text-decoration: none; /* Remove underline */
        }

        &:hover{
          background: #e9e9e9;
          color: var(--black);
        }

        &.approve-action {
          color: var(--green);
          &:hover {
            background: #e6ffe6;
          }
        }
        &.decline-action {
          color: var(--red);
          &:hover {
            background: #ffe6e6;
          }
        }
      }
    }
  }

  .content_div{
    display:flex;
    flex-direction: row;
    padding: 1rem 2rem;
    background: #fdfdfd; /* Slightly different background for expanded content */
    border-top: 1px solid #eee;
    width:100%;
    box-shadow: inset 0 2px 5px rgba(0,0,0,0.03); /* Subtle inner shadow */

    h3{
      color: #999;
      margin-bottom: 1rem;
      font-size: 1.1rem;
      text-align: left; /* Align h3 left within expanded section */
    }

    span{
      margin: 0.5rem 0;
      display: block; /* Ensure each span takes a new line */
      color: var(--dark-gray);
      text-align: left; /* Align span text left */
      line-height: 1.4;

      a {
        color: var(--blue);
        text-decoration: underline;
        display: inline-flex;
        align-items: center;
        svg {
          margin-right: 5px;
        }
      }
    }

    > div:first-child{
      border-right: 1px solid #eee;
      margin-right: 2rem;
      padding-right: 2rem;
      flex: 1; /* Take up available space */
    }

    > div{
      display: flex;
      flex-direction: column;
      flex: 1; /* Take up available space */
    }
  }
`;

// --- Loading Component Styles ---
const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const Loading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: var(--light-black);

  svg {
    animation: ${spin} 1s linear infinite;
    margin-bottom: 1rem;
    color: var(--yellow); /* Example color for spinner */
  }

  h1 {
    font-size: 1.5rem;
    color: var(--black);
  }
`;

// --- Modal Styles ---
export const ModalContent = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6); /* Slightly darker overlay */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(2px); /* Subtle blur effect */
`;

export const DivModal = styled.div`
  background: #fff;
  padding: 2.5rem; /* Increased padding */
  border-radius: 12px; /* More rounded corners */
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2); /* More prominent shadow */
  width: 90%;
  max-width: 550px; /* Slightly wider modal */
  text-align: center;
  position: relative;
  animation: fadeIn 0.3s ease-out; /* Fade-in animation */

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-20px); }
    to { opacity: 1; transform: translateY(0); }
  }

  div:first-child { /* Close button div */
    position: absolute;
    top: 1rem;
    right: 1rem;
    cursor: pointer;
    color: var(--gray);
    transition: color 0.2s;
    &:hover {
      color: var(--red); /* Red on hover for close */
    }
  }

  h2 {
    margin-bottom: 1.5rem; /* More spacing */
    color: var(--black);
    font-size: 1.8rem; /* Larger font size */
  }

  p {
    margin-bottom: 0.7rem;
    color: var(--dark-gray);
    font-size: 1.1rem;
    strong {
      color: var(--black); /* Highlight strong text */
    }
  }
`;

export const ButtonsGroup = styled.div`
  display: flex;
  justify-content: center; /* Center buttons */
  margin-top: 2rem; /* More spacing */
  gap: 1.5rem; /* Space between buttons */

  button {
    padding: 0.8rem 2rem; /* Adjust button padding */
    font-size: 1rem;
    font-weight: bold;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.2s; /* Smooth transitions for buttons */

    &:first-child { /* Cancel button */
      background: red;
      color: #fff;
      &:hover {
        opacity: 0.9;
        transform: translateY(-2px);
      }
    }
    &:last-child { /* Confirm button */
      background: lightgreen;
      color: #fff;
      &:hover {
        opacity: 0.9;
        transform: translateY(-2px);
      }
    }
  }
`;
